import { baseAPIPathGuruKS } from 'configs/api'
import { ROLES_ALLOWED_CHANGE_REGION } from 'configs/roles'

import { useQueryApi } from 'utils/api'
import { usePermission } from 'utils/hooks/usePermission'

import { RegionType } from 'types/region-type'

const basePath = `${baseAPIPathGuruKS}/v1/regions`

export interface RegionDetail {
  id: string
  name: string
  type?: RegionType
}

export interface Region {
  province: RegionDetail
  cities: RegionDetail[]
}

export interface ParamsGetRegionDetail {
  type?: RegionType
}

export interface ResponseSuccessGetRegions {
  regions: Region[]
}

export const useAPIGetRegions = () => {
  const { checkPermissions } = usePermission()

  return useQueryApi<ResponseSuccessGetRegions>(basePath, {
    queryConfig: {
      useErrorBoundary: false,
      enabled: checkPermissions({ allow: ROLES_ALLOWED_CHANGE_REGION }),
    },
  })
}

export const useAPIGetRegionDetail = (
  regionId: string,
  params: ParamsGetRegionDetail = {}
) =>
  useQueryApi<RegionDetail>(`${basePath}/${regionId}`, {
    axiosConfig: {
      params,
    },
    queryConfig: {
      enabled: !!regionId,
    },
  })
